/** PostHog client configuration for error tracking.
 *
 * The project token and API host are intentionally hardcoded: the API host points at
 * Badger's managed reverse proxy (`s.badgercards.ch`), and `ui_host` tells the SDK where
 * the real PostHog UI lives so that links (session replays, issues) resolve correctly
 * back to PostHog through the proxy. See https://posthog.com/docs/error-tracking/installation/react
 */
import type { PostHogConfig } from 'posthog-js'

export const POSTHOG_PROJECT_TOKEN = 'phc_xDq3qYUyqX53cHCSLXSumyR8w67XX8YDPcykJWbPvif9'

export const posthogOptions: Partial<PostHogConfig> = {
  api_host: 'https://s.badgercards.ch', // Badger's managed reverse proxy domain
  ui_host: 'https://eu.posthog.com', // real PostHog UI, so links point back correctly through the proxy
  defaults: '2026-05-30',
  person_profiles: 'identified_only', // only create profiles for identified users
}
